export enum PopupActionType {
  CONTINUE = "continue",
  DRAFT_TOKENS = "draft-tokens",
  EXTERNAL_LINK = "external-link",
  IN_APP_PURCHASE = "in-app-purchase",
}
